export default __webpack_public_path__ + "static/Points-4db635163e3ece0bd6ad6477c23b7fdf.webp";